"use client";

import React, { useEffect, useState } from "react";
import Translations from "@translate/components/Member/CheckoutConfirming/CheckoutConfirmingOverlay";
import { Icon } from "@ospweb/sdk-ui";
import { I18nUtil } from "@utils/i18n";

const I18n = I18nUtil.createScoped(Translations);

interface CheckoutConfirmingOverlayProps {
  open: boolean;
}

/**
 * 托管收银台回跳后的确认提示（EDG-552，fe-spec §4.6 F4）。
 *
 * 原先是整屏不可关闭的遮罩：页面没渲染出来时就是一张空白页，最长约 12 秒（beta 2026-10-14 A10、A6）。
 * 现在是页面上方的提示条：不挡页面、可关闭，关闭只是收起提示，确认在后台继续，生效后照常弹成功弹窗。
 * 防重复下单改由调用方在确认期间禁用购买按钮（`Member.tsx`），不再靠挡住整个页面。
 */
export const CheckoutConfirmingOverlay: React.FC<
  CheckoutConfirmingOverlayProps
> = ({ open }) => {
  const [dismissed, setDismissed] = useState(false);
  useEffect(() => {
    if (!open) {
      setDismissed(false);
    }
  }, [open]);
  if (!open || dismissed) {
    return null;
  }
  return (
    <div
      role="status"
      aria-live="polite"
      data-testid="checkout-confirming-overlay"
      className="fixed left-1/2 top-4 z-[1000] flex -translate-x-1/2 items-center gap-3 rounded-2 bg-background_solid_primary px-4 py-3 shadow-lg"
    >
      <Icon name="ic_loading2" size={20} className="animate-spin" />
      <p className="body_m text-content_primary">
        {I18n.t("Confirming your payment…")}
      </p>
      <button
        type="button"
        aria-label="Close"
        data-openreplay-label="checkout_confirming_close"
        className="cursor-pointer button_icon"
        onClick={() => {
          setDismissed(true);
        }}
      >
        <Icon name="close" size={16} className="text-content_primary" />
      </button>
    </div>
  );
};
